module.exports = __webpack_public_path__ + "static/spiroflex-8a746594872eb442b9ceda2be43ced22.png";